module.exports = __webpack_public_path__ + "static/media/santas-lil-helper.ebbeb55f.jpg";